


import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { ValidateEmail } from "@Internal/Utils";
import { CustomError } from "App/Models";

@Component
export default class EmailField extends Vue {
    @Prop() public Id!: string;
    @Prop() public Placeholder!: string;
    @Prop() public Value!: string;

    private value: string = "";
    private email?: string;
    private validation?: CustomError;

    private state: "untouched" | "valid" | "invalid" = "untouched";

    private validate() {
        if( this.value === "" ) {
            this.email = undefined;

            /* Required fields are validated by Form field component when needed.
            This condition ignores email Validation if the value is empty. */
            this.validation = undefined;

            return;
        }

        this.email = this.value;

        this.validation = ValidateEmail( this.email );

        this.state = this.validation instanceof CustomError ? "invalid" : "valid";
    }

    @Watch( "Value" )
    private onValueChange( value: string | undefined ) {
        if( value !== undefined )
            this.value = value;
    }

    @Watch( "value" )
    private onInternalValueChange( value: string ) {
        /* No need to emit the value if it didn't change. */
        if( this.Value !== undefined && this.Value === value )
            return;

        this.validate();

        /* If the input field is empty send an undefined value, just like we the value we receive
           from the relevant prop (Value). */
        this.$emit( "Value", this.email, this.validation );
    }
}
